import FlexColumn from "designSystem/components/flex/FlexColumn";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import { RequestErrorPlaceholder } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { FallbackProps } from "react-error-boundary";

/**
 * TODO - make the UI more fancy
 */
export const ErrorFallback: FunctionComponent<FallbackProps> = ({ error, resetErrorBoundary }) => {
	return (
		<FlexColumn>
			<FlexRowCenter
				flexGrow={1}
				justifyContent="center"
				px={3}
			>
				<RequestErrorPlaceholder
					onRetry={resetErrorBoundary}
					subtitleRes="CustomViewRunTimeError"
					subtitleResParams={[error]}
				/>
			</FlexRowCenter>
		</FlexColumn>
	);
};